module.exports = __webpack_public_path__ + "img/65.0f151368.jpg";